var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h_icon"},_vm._l((_vm.iconList),function(icon){return _c('div',{key:`icon${icon.i_idx}`,staticClass:"snsimg",style:(`background-image:url(${_vm.returnIconImage(icon)})`),on:{"click":function($event){return _vm.openUrl(icon.i_url)}}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }